<ul>
<li *ngFor="let kleur of studiewijzerKleuren()">
    <div class="blokje" [ngStyle]="{'background-color': kleur}"></div>
    <p>{{kleur}}</p>
</li>
</ul>
